import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "app-channel-facebook",
  "use": "app-channel-facebook-usage",
  "viewBox": "0 0 32 32",
  "content": "<symbol fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\" id=\"app-channel-facebook\"><path clip-rule=\"evenodd\" d=\"M24.173 10.333h-5.68V7.786a1.333 1.333 0 011.333-1.466h4V.986h-5.773c-5.24 0-6.227 4-6.227 6.48v2.867h-4v5.333h4V31h6.667V15.666h5.133l.547-5.333z\" stroke=\"currentColor\" stroke-width=\"1.5\" stroke-linecap=\"round\" stroke-linejoin=\"round\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/img/svg/app-channel-facebook.svg
// module id = JFTI
// module chunks = 39 44